import ErrorDispatcher from './ErrorDispatcher';

export class ScheduledLessonNotFoundError implements ErrorDispatcher {
  constructor(
    private readonly scheduledLessonId: number,
    private readonly klassId: number,
    private readonly page: number,
  ) {}

  public getError() {
    return new Error(
      `Scheduled lesson not found - scheduledLesson: ${this.scheduledLessonId} - klass: ${this.klassId} - page: ${this.page}`,
    );
  }
}

export class ScheduledLessonByKlassNotFoundDispatcher
  implements ErrorDispatcher
{
  constructor(private readonly klassId: number) {
    this.klassId = klassId;
  }

  public getError() {
    return new Error(
      `Scheduled lesson not found in this klass: ${this.klassId}`,
    );
  }
}

export class ScheduledLessonWithoutLessonErrorDispatcher
  implements ErrorDispatcher
{
  constructor(
    private readonly scheduledLessonId: Array<number>,
    private readonly klassId: number,
    private readonly page: string,
  ) {
    this.scheduledLessonId = scheduledLessonId;
    this.klassId = klassId;
    this.page = page;
  }

  public getError() {
    return new Error(
      `Scheduled lesson without lesson - scheduledLesson: ${this.scheduledLessonId} - klass: ${this.klassId} page: ${this.page}`,
    );
  }
}
